import React, { useState, useEffect, useContext } from 'react'
import {
    Row,
    Col,
    Input,
    Card,
    CardBody,
    Table
} from 'reactstrap'

import { Link, withRouter } from 'react-router-dom'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'

const Datatable = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])

    useEffect(() => {
        (async () => {
            await _fetchData()
        })()
    }, []) // eslint-disable-line

    const _fetchData = async () => {
        setLoading(true)
        try {
            const response = await ApiService.getCustomers()

            setData(response.data.customers)
            setFilteredData(response.data.customers)
            setLoading(false)
        } catch (error) {
            toastr.error(`Oop's! I couldn't find any customers`)
        } finally {
            setLoading(false)
        }
    }

    const _filterData = async (e) => {
        const keystroke = e.target.value.toLowerCase()
        const filteredData = data.filter((item) => {
            const businessName = item.businessName || ''
            const taxId = item.taxId || ''

            return businessName.toLowerCase().includes(keystroke) ||
                taxId.toLowerCase().includes(keystroke)
        })

        setFilteredData(filteredData)
    }

    const _deleteItem = async (id) => {
        setLoading(true)

        try {
            const result = await ApiService.deleteCustomer(id)

            if (!result.data.success) {
                toastr.error(`I couldn't delete this customer`, 'Error')

                return false
            }

            let filtered = await data.filter((v) => { return v.id !== id })

            setData(filtered)
            setFilteredData(filtered)

            toastr.success(`I deleted a customer`, '¡Éxito!')
            window.analytics.track('Customer Deleted', {
                customerId: id
            })
        } catch (error) {
            console.log(error)

            toastr.error(`I couldn't delete this customer`, 'Error')
        } finally {
            setLoading(false)
        }
    }

    return(
        <React.Fragment>
            <Row className="mb-2">
                <Card>
                    <CardBody>
                    <Col sm="4">
                        <div className="search-box mr-2 mb-2 d-inline-block">
                            <div className="position-relative">
                                <Input type="text" className="form-control"
                                    placeholder={`Buscar`}
                                    onKeyUp={(e) => _filterData(e)}
                                />
                                <i className="bx bx-search-alt search-icon"></i>
                            </div>
                        </div>
                    </Col>
                    <Col sm="8">
                        <div className="text-sm-right">
                            <Link to={`/customers/add`} className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2">
                                <i className="mdi mdi-plus mr-1"></i> Agregar Cliente
                            </Link>

                            {/* <Link to={`/customers/import`} className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2">
                                <i className="mdi mdi-import mr-1"></i> Importar Clientes
                            </Link> */}
                        </div>
                    </Col>
                    </CardBody>
                </Card>
            </Row>

            <Row>
                <Card>
                    <CardBody>
                        <div className="table-responsive">
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Cumpleaños</th>
                                        <th>RFC</th>
                                        <th>Email</th>
                                        <th>Teléfono</th>
                                        <th>...</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredData.length === 0 && (
                                        <tr>
                                            <td colSpan="6" className="text-center py-4 text-muted">
                                                No se encontraron clientes.
                                            </td>
                                        </tr>
                                    )}

                                    {filteredData && filteredData.map((item, key) => (
                                        <tr key={key}>
                                            <td>{item.fullName}</td>
                                            <td>{item.dob}</td>
                                            <td>{item.taxId}</td>
                                            <td>{item.email}</td>
                                            <td>{item.phone}</td>
                                            <td>
                                                <div className="d-flex gap-2">
                                                    <div className="flex-fill">
                                                        <Link id={'edit'} to={`/branches/${item.id}`}>
                                                            <i title='Sucursales' className="mdi mdi-home"></i>
                                                        </Link>
                                                    </div>
                                                    <div className="flex-fill">
                                                        <Link id={'edit'} to={`/customers/edit/${item.id}`}>
                                                            <i className="mdi mdi-pencil"></i>
                                                        </Link>
                                                    </div>

                                                    <div className="flex-fill">
                                                        <Link id={'delete'} to={`#`} onClick={(e) => {
                                                            e.preventDefault()
                                                            _deleteItem(item.id)
                                                        }}>
                                                            <i className="mdi mdi-trash-can font-size-16 mr-2"></i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>                
            </Row>
        </React.Fragment>
    )
}

export default withRouter(Datatable)